export const SULAHUB_ROLES = {
    SYSTEM_PROFILES: {
        SULA_USER: 'squad_user',
        MESA_PLUS_ADMIN: 'admin_plus_user',
        OPERATION_USER: 'operation_user',
        TP_USER: 'tp_user',
        REQUESTER_USER: 'requester_user',
        TP_ADMIN_USER: 'tp_admin_user',
        INTEGRATION_USER: 'integration_user',
        ONTIMELEILAO_USER: 'ontimeleilao_user',
        SMARTCARGAS_USER: 'smartcargas_user',
    },
} as const;

export const SULAHUB_USERS_TYPES = [
    {
        value: SULAHUB_ROLES.SYSTEM_PROFILES.MESA_PLUS_ADMIN,
        label: 'Admin. Mesa',
    },
    {
        value: SULAHUB_ROLES.SYSTEM_PROFILES.TP_ADMIN_USER,
        label: 'Admin. Transportadora',
    },
    {
        value: SULAHUB_ROLES.SYSTEM_PROFILES.TP_USER,
        label: 'Operador Transportadora',
    },
    {
        value: SULAHUB_ROLES.SYSTEM_PROFILES.REQUESTER_USER,
        label: 'Solicitante',
    },
    { value: SULAHUB_ROLES.SYSTEM_PROFILES.SULA_USER, label: 'Sula' },
    { value: SULAHUB_ROLES.SYSTEM_PROFILES.OPERATION_USER, label: 'Operação' },
    {
        value: SULAHUB_ROLES.SYSTEM_PROFILES.INTEGRATION_USER,
        label: 'Integração',
    },
];

export const SULAHUB_USERS_BY_USER_TYPE = [
    { value: 0, label: 'Operador Transportadora' },
    { value: 1, label: 'Admin. Transportadora' },
    { value: 2, label: 'Solicitante' },
    { value: 3, label: 'Operação' },
    { value: 4, label: 'Admin. Mesa' },
    { value: 5, label: 'Sula' },
    { value: 6, label: 'Integração' },
];
